import React from 'react';
import { RakutenIcon } from '@next-common/material-ui-icons';
import { useStyles } from './Label.style';
export const Label = (props) => {
    const { label, icon } = props;
    const classes = useStyles(props);
    return (React.createElement("span", { className: classes.label, "data-qa": "label" },
        React.createElement(RakutenIcon, { icon: icon, style: { fontSize: 14, marginRight: 5 } }),
        " ",
        label));
};
